import style from './EhrFiles.module.scss';

import { FileDragAndDrop } from '@components/FileDragAndDrop';
import { FileViewModel } from 'chaika-frontend-types/frontend-cms';

export interface EhrFilesProps {}

interface Props extends EhrFilesProps {
    createFileAssetApi(fileName: string): Promise<FileViewModel>;
    setFileUploadedStatusApi(fileName: string): Promise<void>;
    onFileAdd(fileAsset: FileViewModel): void;
}

export function AddFile({ onFileAdd, createFileAssetApi, setFileUploadedStatusApi }: Props) {
    return (
        <div className={style.fileDragAndDrop}>
            <FileDragAndDrop
                createFileAssetApi={createFileAssetApi}
                setFileUploadedStatusApi={setFileUploadedStatusApi}
                onFileLoaded={onFileAdd}
            />
        </div>
    );
}
